import { render } from "./PasoNegocio.vue?vue&type=template&id=4113aab5&scoped=true"
import script from "./PasoNegocio.vue?vue&type=script&lang=js"
export * from "./PasoNegocio.vue?vue&type=script&lang=js"

import "./PasoNegocio.vue?vue&type=style&index=0&id=4113aab5&lang=scss&scoped=true"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4113aab5"]])

export default __exports__